/* Avelmont Outlet — store behaviour (cart drawer, menu, product page, gallery). No dependencies. */
(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const openDialog = (d) => { if (d && !d.open) { d.showModal(); document.documentElement.style.overflow = 'hidden'; } };
  const closeDialog = (d) => { if (d && d.open) { d.close(); } };
  document.addEventListener('close', () => { if (!$$('dialog[open]').length) document.documentElement.style.overflow = ''; }, true);
  // click on backdrop closes dialogs
  document.addEventListener('click', (e) => { if (e.target.tagName === 'DIALOG' && e.target.open) closeDialog(e.target); });

  /* ---------- Cart ---------- */
  const drawer = () => $('#ao-cart-drawer');
  const setCount = (n) => $$('[data-ao-count]').forEach((el) => { el.textContent = n; el.hidden = n < 1; });
  async function renderCart() {
    const r = await fetch(`${root}cart?section_id=ao-cart-drawer`, { credentials: 'same-origin' });
    const html = await r.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-ao-cart]');
    $$('[data-ao-cart]').forEach((cur) => { if (fresh) cur.replaceWith(fresh.cloneNode(true)); });
    const n = fresh ? Number(fresh.dataset.count || 0) : 0;
    setCount(n);
  }
  async function cartChange(key, quantity) {
    $$('[data-ao-cart]').forEach((c) => c.classList.add('is-busy'));
    try {
      await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    } finally { await renderCart(); }
  }
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-ao-cart-open]');
    if (open && drawer()) { e.preventDefault(); openDialog(drawer()); return; }
    const close = e.target.closest('[data-ao-cart-close]');
    if (close) { closeDialog(close.closest('dialog')); return; }
    const q = e.target.closest('[data-ao-qty]');
    if (q) { e.preventDefault(); cartChange(q.dataset.key, Number(q.dataset.qty)); }
  });

  /* ---------- Menu + modals ---------- */
  document.addEventListener('click', (e) => {
    const m = e.target.closest('[data-ao-open]');
    if (m) { e.preventDefault(); openDialog(document.getElementById(m.dataset.aoOpen)); return; }
    const c = e.target.closest('[data-ao-close]');
    if (c) closeDialog(c.closest('dialog'));
  });

  /* ---------- Collection sort ---------- */
  document.addEventListener('change', (e) => {
    const s = e.target.closest('[data-ao-sort]');
    if (!s) return;
    const u = new URL(location.href);
    u.searchParams.set('sort_by', s.value);
    u.searchParams.delete('page');
    location.href = u.toString();
  });

  /* ---------- Product page ---------- */
  class AoProduct extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('script[data-ao-json]');
      if (!data) return;
      this.data = JSON.parse(data.textContent);
      this.form = this.querySelector('[data-ao-form]');
      this.idInput = this.querySelector('[name="id"]');
      this.btn = this.querySelector('[data-ao-add]');
      this.msg = this.querySelector('[data-ao-msg]');
      this.stage = this.querySelector('[data-ao-stage]');
      this.addEventListener('change', (e) => { if (e.target.matches('[data-ao-option]')) this.onOption(); });
      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));
      this.setupGallery();
      this.setupSticky();
      this.markSizes();
    }
    selected() { return $$('[data-ao-option]:checked', this).sort((a, b) => a.dataset.index - b.dataset.index).map((i) => i.value); }
    variantFor(opts) { return this.data.variants.find((v) => v.options.every((o, i) => o === opts[i])); }
    onOption() {
      const opts = this.selected();
      const v = this.variantFor(opts);
      $$('[data-ao-selected]', this).forEach((el) => { const i = Number(el.dataset.aoSelected); el.textContent = opts[i] || ''; });
      this.markSizes();
      if (!v) { this.setButton(null); return; }
      this.idInput.value = v.id;
      this.querySelectorAll('[data-ao-price]').forEach((el) => { el.innerHTML = v.price_html; });
      this.setButton(v);
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
      const mi = v.media_index != null ? v.media_index : (this.data.color_media || {})[opts[this.data.color_index]];
      if (mi != null) this.goTo(mi);
      document.dispatchEvent(new CustomEvent('ao:variant', { detail: v }));
    }
    setButton(v) {
      const label = this.btn.querySelector('[data-ao-add-label]');
      const sticky = $('[data-ao-sticky-label]');
      let text;
      if (!v) { this.btn.disabled = true; text = this.data.t.unavailable; }
      else if (!v.available) { this.btn.disabled = true; text = this.data.t.sold; }
      else { this.btn.disabled = false; text = `${this.data.t.add} — ${v.price_plain}`; }
      label.textContent = text;
      if (sticky) { sticky.textContent = v && v.available ? this.data.t.add : text; sticky.closest('button').disabled = this.btn.disabled; }
      const sp = $('[data-ao-sticky-price]'); if (sp && v) sp.innerHTML = v.price_plain;
      const sv = $('[data-ao-sticky-variant]'); if (sv && v) sv.textContent = v.title;
    }
    markSizes() {
      // For each value of the size option, mark unavailable given the other selections
      const idx = this.data.size_index;
      if (idx == null) return;
      const opts = this.selected();
      $$(`[data-ao-option][data-index="${idx}"]`, this).forEach((input) => {
        const test = opts.slice(); test[idx] = input.value;
        const v = this.variantFor(test);
        input.closest('.ao-size').classList.toggle('is-out', !v || !v.available);
      });
    }
    async onSubmit(e) {
      e.preventDefault();
      this.btn.disabled = true; this.msg.textContent = '';
      const label = this.btn.querySelector('[data-ao-add-label]'); const old = label.textContent; label.textContent = this.data.t.adding;
      try {
        const r = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(this.form) });
        if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.description || this.data.t.error); }
        await renderCart();
        openDialog(drawer());
      } catch (err) { this.msg.textContent = err.message || this.data.t.error; }
      finally { label.textContent = old; this.btn.disabled = false; }
    }
    setupGallery() {
      if (!this.stage) return;
      this.slides = $$('[data-ao-slide]', this.stage);
      this.dots = $$('[data-ao-dot]', this); this.thumbs = $$('[data-ao-thumb]', this);
      const mark = (i) => { [...this.dots, ...this.thumbs].forEach((b) => b.setAttribute('aria-current', String(Number(b.dataset.i) === i))); this.cur = i; };
      this.cur = 0;
      const io = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting && en.intersectionRatio > 0.6) mark(this.slides.indexOf(en.target)); }), { root: this.stage, threshold: [0.6] });
      this.slides.forEach((s) => io.observe(s));
      [...this.dots, ...this.thumbs].forEach((b) => b.addEventListener('click', () => this.goTo(Number(b.dataset.i))));
      const prev = $('[data-ao-prev]', this), next = $('[data-ao-next]', this);
      if (prev) prev.addEventListener('click', () => this.goTo(Math.max(0, this.cur - 1)));
      if (next) next.addEventListener('click', () => this.goTo(Math.min(this.slides.length - 1, this.cur + 1)));
      const zoom = $('[data-ao-zoom]', this);
      if (zoom) this.slides.forEach((s) => s.addEventListener('click', () => { $('img', zoom).src = s.dataset.full; openDialog(zoom); }));
      const start = this.data.start_media; if (start) requestAnimationFrame(() => this.goTo(start, 'instant'));
    }
    goTo(i, behavior = 'smooth') {
      if (!this.slides || !this.slides[i]) return;
      this.stage.scrollTo({ left: i * this.stage.clientWidth, behavior });
      this.cur = i;
      [...this.dots, ...this.thumbs].forEach((b) => b.setAttribute('aria-current', String(Number(b.dataset.i) === i)));
    }
    setupSticky() {
      const bar = $('[data-ao-sticky]');
      if (!bar || !this.btn) return;
      const io = new IntersectionObserver(([en]) => bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0));
      io.observe(this.btn);
      bar.querySelector('button').addEventListener('click', () => {
        if (!this.btn.disabled) this.form.requestSubmit(); else this.btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }
  if (!customElements.get('ao-product')) customElements.define('ao-product', AoProduct);
})();